export default "__VITE_ASSET__8af1380d__"